import { useChannel as useAblyChannel } from "ably/react";
import {
  SuggestedActionMessageSchema,
  type SuggestedActionPayload,
  suggestedActionChannelName,
} from "@remi/types/socket/message";

export const useSuggestedActionChannel = (personId: string, callback: (action: SuggestedActionPayload) => void) => {
  return useAblyChannel(suggestedActionChannelName(personId), (message) => {
    const parsed = SuggestedActionMessageSchema.safeParse(message as unknown);
    if (!parsed.success) {
      return;
    }
    callback(parsed.data.data);
  });
};
